import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Box, DropdownCard, Icon, type ITabItem, Tabs } from 'shared/ui'
import { MergeField } from 'widgets/MergeField'
import type { AgentInstructionsStore } from 'pages/chatbot/pages/calling/ui/AICallingAgentManage/ui/AgentInstructions/store/AgentInstructionsStore.tsx'
import { sendSMS } from 'pages/chatbot/pages/calling/ui/AICallingAgentManage/ui/AgentInstructions/actions/sendSMS/sendSMS.tsx'
import { handoffToHuman } from 'pages/chatbot/pages/calling/ui/AICallingAgentManage/ui/AgentInstructions/actions/handoffToHuman/handoffToHuman.tsx'

export const ShortcutContent = observer(
  ({ store, onClose }: { store: AgentInstructionsStore; onClose: () => void }) => {
    const { onChooseMergeField, mergeFieldConfig, onAddHandoffToHumanAction, onAddSMSAction } =
      store

    const [activeTabKey, setActiveTabKey] = useState<'merge_fields' | 'actions'>('merge_fields')

    const tabs: ITabItem<typeof activeTabKey>[] = [
      { key: 'merge_fields', name: 'Merge fields' },
      {
        key: 'actions',
        name: 'Actions',
      },
    ]

    const onSendSMS = () => {
      onClose()
      sendSMS({ onSave: onAddSMSAction })
    }

    const onHandoff = () => {
      onClose()
      handoffToHuman({ onSave: onAddHandoffToHumanAction })
    }

    return (
      <Box width={'280px'}>
        <Tabs
          uiClasses={['fullDivider', 'p8']}
          activeTabKey={activeTabKey}
          handleSelectTab={(tab) => setActiveTabKey(tab.key)}
          tabs={tabs}
        />
        {activeTabKey === 'merge_fields' && (
          <MergeField
            onCloseMenu={onClose}
            isNoAutoFocus
            onAddMergeField={(field) => onChooseMergeField(field, '/')}
            isFullWidth
            {...mergeFieldConfig}
          />
        )}
        {activeTabKey === 'actions' && (
          <Box padding={0.5}>
            <DropdownCard
              item={{
                id: 'sendSMS',
                label: 'Send SMS',
                customIconL: (
                  <Icon icon={'messageTextCircle02'} color={'var(--content-brand-primary)'} />
                ),
                onClick: onSendSMS,
              }}
            />
            <DropdownCard
              item={{
                id: 'handoff',
                label: 'Handoff to human',
                customIconL: <Icon icon={'userRight'} color={'var(--content-brand-primary)'} />,
                onClick: onHandoff,
              }}
            />
          </Box>
        )}
      </Box>
    )
  }
)
